<template>
<div class="grid mt-4">	
<template v-if="!is_connected">


<div class="col-12 ">
<h4 class="text-red-500">Bu modüle bağlı bir veri modülü bulunmuyor</h4>
</div>	
</template>

<template v-else>

<div class="col-12 ">
<h4 class="text-primary">Listelenecek Girdileri Seçin</h4>
</div>	

<div class="col-12 pb-5">
<span class="p-float-label">
<Dropdown :filter="false"  v-model="selected_input" :options="inputs" optionLabel="name"   class="w-full p-inputtext-sm" @change="inputSelected"/>
<label  class="text-primary">Bir Giriş Seçin</label>
</span>
</div>





<template v-if="show_add_output">

<div class="col-12">
<h4 class="text-primary">Yeni Sütun Alanı</h4>
</div>

<div class="col-12 pb-5" v-if="show_value_input">
<span class="p-float-label">
<InputText  type="text" v-model="new_item.value" class="w-full p-inputtext-sm"    />
<label  class="text-primary">Hücrede Görünecek Değer</label>
</span>
</div>	


<div class="col-12">
<span class="p-float-label">
<InputText  type="text" v-model="new_item.name" class="w-full p-inputtext-sm"    />
<label  class="text-primary">Sütun İsmi</label>
</span>
</div>


<div class="col-6 flex mt-2" v-if="!show_value_input">
  <label  class="text-primary">Sıralanabilir</label>
  <InputSwitch v-model="new_item.sortable" class="ml-2"/> 
</div>
<div class="col-6 flex mt-2" v-if="!show_value_input">
  <label  class="text-primary">Filtrelenebilir</label>
  
  <InputSwitch v-model="new_item.filterable"  class="ml-2"/>
</div>


<div class="col-12">
<div class="flex flex-wrap gap-3">


<div class="flex align-items-start">
  <RadioButton v-model="new_item.grouping_method" inputId="deger_toplam" name="deger_toplam" value="deger_toplam" />
  <label for="deger_toplam" class="ml-2">Değer Toplamı</label>
</div>
<div class="flex align-items-start">
  <RadioButton v-model="new_item.grouping_method" inputId="supplier_toplam" name="supplier_toplam" value="supplier_toplam" />
  <label for="supplier_toplam" class="ml-2">Tedarikçi Sayısı</label>
</div>
<div class="flex align-items-start">
  <RadioButton v-model="new_item.grouping_method" inputId="ortalama" name="toplam" value="ortalama" />
  <label for="ortalama" class="ml-2">Ortalama</label>
</div>


</div>
</div>


<div class="col-12">
<h4>Alan Çevirileri</h4>
</div>

<div class="col-12 pb-5" v-for="element in new_item.translations">
<span class="p-float-label">
<InputText  type="text" v-model="element.name" class="w-full p-inputtext-sm"    />
<label  class="text-primary">{{element.language.name}} için Sütun İsmi</label>
</span>
</div>

<div class="col-12 pb-5">
<div class="flex align-items-center justify-content-end ">
<Button label="İptal"  class="p-button-outlined p-button-sm p-button-danger mr-2"  type="cancel" @click="cancelNewItem"></Button>
<Button label="Kaydet"  class="p-button-outlined p-button-sm p-button-primary"  type="submit" @click="submitNewItem"></Button>
</div>
</div>

	 
</template>
















<div class="col-12 ">
<h4 class="text-primary">Listeleme Sütunları</h4>
</div>


<div class="col-12 ">
<draggable 
v-model="$store.state.calculations.selectednode.data.outputs"
class="grid" 
@start="start" 
@end="end" 
@change="change"
handle=".handle"
v-bind="dragOptions"
item-key="id">


<!--item column-->
<template #item="{element}">	
<div class="col-12" >

<!--item viewing-->
<div class="grid" v-if="!element.is_editing">
<div class="col-1 handle">	
<span class="material-symbols-outlined">
drag_handle
</span>

</div>
<div class="col-9"><small>{{element.name}}</small></div>
<div class="col-2">
<Button type="button"  icon="pi pi-pencil" @click="editItem(element.id)" class="p-button-primary p-button-outlined p-button-sm mr-2"   />
<Button type="button"  icon="pi pi-times" @click="deleteItem(element.id)" class="p-button-danger p-button-outlined p-button-sm "  />
</div>
</div>
<!--item viewing-->

<!--item editing-->
<div class="grid raised_item pt-6" v-if="element.is_editing">


<div class="col-12 pb-5" v-if="editing_item.type=='value'">
<span class="p-float-label">
<InputText  type="text" v-model="editing_item.value" class="w-full p-inputtext-sm"    />
<label  class="text-primary">Hücrede Görünecek Değer</label>
</span>
</div>	

<div class="col-12">
<span class="p-float-label">
<InputText  type="text" v-model="editing_item.name" class="w-full p-inputtext-sm"    />
<label  class="text-primary">Sütun İsmi</label>
</span>
</div>

<div class="col-6 flex mt-2" v-if="editing_item.type!=='value'">
  <label  class="text-primary">Sıralanabilir</label>
  <InputSwitch v-model="editing_item.sortable" class="ml-2"/> 
</div>
<div class="col-6 flex mt-2" v-if="editing_item.type!=='value'">
  <label  class="text-primary">Filtrelenebilir</label>
  
  <InputSwitch v-model="editing_item.filterable"  class="ml-2"/>
</div>

<div class="col-12">
<div class="flex flex-wrap gap-3">


<div class="flex align-items-start">
  <RadioButton v-model="editing_item.grouping_method" :inputId="'deger_toplam'+editing_item.id" name="deger_toplam" value="deger_toplam" />
  <label :for="'deger_toplam'+editing_item.id" class="ml-2">Değer Toplamı</label>
</div>
<div class="flex align-items-start">
  <RadioButton v-model="editing_item.grouping_method" :inputId="'supplier_toplam'+editing_item.id" name="supplier_toplam" value="supplier_toplam" />
  <label :for="'supplier_toplam'+editing_item.id" class="ml-2">Tedarikçi Sayısı</label>
</div>
<div class="flex align-items-start">
  <RadioButton v-model="editing_item.grouping_method" :inputId="'toplam'+editing_item.id" name="toplam" value="ortalama" />
  <label :for="'ortalama'+editing_item.id" class="ml-2">Ortalama</label>
</div>


</div>
</div>



<div class="col-12">
<h4>Alan Çevirileri</h4>
</div>


<div class="col-12 pb-5" v-for="item in editing_item.translations">
<span class="p-float-label">
<InputText  type="text" v-model="item.name" class="w-full p-inputtext-sm"    />
<label  class="text-primary">{{item.language.name}} için Sütun İsmi</label>
</span>
</div>

<div class="col-12 pb-5">
<div class="flex align-items-center justify-content-end ">
<Button label="İptal"  class="p-button-outlined p-button-sm p-button-danger mr-2"  type="cancel" @click="cancelEditItem(editing_item.id)"></Button>
<Button label="Kaydet"  class="p-button-outlined p-button-sm p-button-primary"  type="submit" @click="submitChanges(editing_item.id)"></Button>
</div>
</div>



</div>

<!--item editing-->
</div>
</template>
<!--item column-->

</draggable>
</div>





<!-- gruplamalar -->

<div class="col-12 "><hr></div>
<div class="col-12 ">
<h4 class="text-primary">Gruplama Niteliklerini Seçin</h4>
</div>  

<div class="col-12 pb-5">
<span class="p-float-label">
<Dropdown :filter="false"  v-model="selected_group_type" :options="group_types" optionLabel="name"   class="w-full p-inputtext-sm" @change="groupTypeSelected"/>
<label  class="text-primary">Bir Gruplama Niteliği Seçin</label>
</span>
</div>

<template v-if="selected_group_type">


<!-- if custom attribute-->
<template v-if="selected_group_type.id=='custom_attribute'">

  <div class="col-12 pb-5">
  <span class="p-float-label">
  <Dropdown :filter="false"  v-model="selected_custom_attribute" :options="custom_attributes" optionLabel="name"   class="w-full p-inputtext-sm" @change="customAttributeSelected"/>
  <label  class="text-primary">Bir Özel Nitelik Seçin</label>
  </span>
  </div>

  <div class="col-12 pb-5" v-if="selected_custom_attribute">
  <span class="p-float-label">
  <Dropdown :filter="true"  v-model="selected_customattribute_option" :options="customattribute_options" optionLabel="name"   class="w-full p-inputtext-sm" @change="customAttributeOptionSelected"/>
  <label  class="text-primary">Bir Nitelik Seçeneği Seçin</label>
  </span>

  </div>

</template>
<!-- if custom attribute-->

<!-- if not ustom attribute-->
<template v-else>
  <div class="col-12 pb-5" >
  <span class="p-float-label">
  <Dropdown :filter="true"  v-model="selected_flow" :options="brand_flows" optionLabel="name"   class="w-full p-inputtext-sm" @change="brandFlowSelected"/>
  <label  class="text-primary">Bir Aşama Seçin</label>
  </span>

  </div>

  <template v-if="selected_group_type.id=='inputfield_section'">
    <div class="col-12 pb-5" v-if="selected_flow">
    <span class="p-float-label">
    <Dropdown :filter="true"  v-model="selected_inputfield_section" :options="inputfield_sections" optionLabel="name"   class="w-full p-inputtext-sm" @change="inputfieldSectionSelected"/>
    <label  class="text-primary">Bir Bölüm Seçin</label>
    </span>
    </div>
  </template>

  <template v-if="selected_group_type.id=='inputfield'">
    <div class="col-12 pb-5" v-if="selected_flow">
    <span class="p-float-label">
    <Dropdown :filter="true"  v-model="selected_inputfield" :options="inputfields" optionLabel="name"   class="w-full p-inputtext-sm" @change="inputfieldSelected"/>
    <label  class="text-primary">Bir Soru Seçin</label>
    </span>
    </div>
  </template>

  <template v-if="selected_group_type.id=='nonconformity_type'">
    <div class="col-12 pb-5" v-if="selected_flow">
    <span class="p-float-label">
    <Dropdown :filter="true"  v-model="selected_nonconformity_type" :options="nonconformitytypes" optionLabel="name"   class="w-full p-inputtext-sm" @change="nonconformityTypeSelected"/>
    <label  class="text-primary">Bir Soru Seçin</label>
    </span>
    </div>
  </template>

  
</template>
<!-- if not ustom attribute-->

</template>














<template v-if="show_group_add_output">

<div class="col-12">
<h4 class="text-primary">Yeni Grup Alanı</h4>
</div>




<div class="col-12">
<span class="p-float-label">
<InputText  type="text" v-model="new_group_item.name" class="w-full p-inputtext-sm"    />
<label  class="text-primary">Sütun İsmi</label>
</span>
</div>



<div class="col-12 pb-5">
<div class="flex align-items-center justify-content-end ">
<Button label="İptal"  class="p-button-outlined p-button-sm p-button-danger mr-2"  type="cancel" @click="cancelNewAttributeItem"></Button>
<Button label="Kaydet"  class="p-button-outlined p-button-sm p-button-primary"  type="submit" @click="submitNewAttributeItem"></Button>
</div>
</div>

   
</template>
















<div class="col-12 ">
<h4 class="text-primary">Gruplar</h4>
</div>


<div class="col-12 ">
<draggable 
v-model="$store.state.calculations.selectednode.data.groups"
class="grid" 
@start="start" 
@end="end" 
@change="change"
handle=".handle"
v-bind="dragOptions"
item-key="id">


<!--item column-->
<template #item="{element}">  
<div class="col-12" >

<!--item viewing-->
<div class="grid" v-if="!element.is_editing">
<div class="col-1 handle">  
<span class="material-symbols-outlined">
drag_handle
</span>

</div>
<div class="col-9"><small>{{element.name}}
<span class="ml-1 text-purple-500" v-if="element.group_type=='custom_attribute'">- <b>Özel Nitelik</b></span>
<span class="ml-1 text-purple-500" v-if="element.group_type=='inputfield_section'">- <b>Soru Listesi Bölümü</b></span>
<span class="ml-1 text-purple-500" v-if="element.group_type=='inputfield'">- <b>Soru</b></span>
<span class="ml-1 text-purple-500" v-if="element.group_type=='nonconformity_type'">- <b>Uygunsuzluk Türü</b></span>



</small></div>
<div class="col-2">
<Button type="button"  icon="pi pi-pencil" @click="editAttributeItem(element.id)" class="p-button-primary p-button-outlined p-button-sm mr-2"   />
<Button type="button"  icon="pi pi-times" @click="deleteAttributeItem(element.id)" class="p-button-danger p-button-outlined p-button-sm "  />
</div>
</div>
<!--item viewing-->

<!--item editing-->
<div class="grid raised_item pt-6" v-if="element.is_editing">




<div class="col-12">
<span class="p-float-label">
<InputText  type="text" v-model="editing_attribute_item.name" class="w-full p-inputtext-sm"    />
<label  class="text-primary">Sütun İsmi</label>
</span>
</div>








<div class="col-12 pb-5">
<div class="flex align-items-center justify-content-end ">
<Button label="İptal"  class="p-button-outlined p-button-sm p-button-danger mr-2"  type="cancel" @click="cancelAttributeEditItem(editing_attribute_item.id)"></Button>
<Button label="Kaydet"  class="p-button-outlined p-button-sm p-button-primary"  type="submit" @click="submitAttributeChanges(editing_attribute_item.id)"></Button>
</div>
</div>



</div>

<!--item editing-->
</div>
</template>
<!--item column-->

</draggable>
</div>




	
</template>


</div>	
</template>

<script>
export default {

  name: 'GroupNodeData',

  data () {
    return {
    	selected_input:null,
    	inputs:[
    	{name:"Text",id:0,type:"value",is_editing:false,sortable:1,filterable:1,grouping_method:"deger_toplam"}
    	],
    	show_value_input:false,
    	show_add_output:false,
    	thevalue:null,
    	languages:[],
    	new_item:null,
    	editing_item:null,
      custom_attributes:[],
      brand_flows:[],
      inputfield_sections:[],
      inputfields:[],
      nonconformitytypes:[],
      selected_group_type:null,
      group_types:[
      {id:"custom_attribute",name:"Özel Nitelik"},
      ],
      selected_custom_attribute:null,
      selected_customattribute_option:null,
      customattribute_options:null,
      selected_flow:null,
      selected_inputfield_section:null,
      selected_inputfield:null,
      selected_nonconformity_type:null,
      new_group_item:{grouping_method:"deger_toplam"},
      show_group_add_output:false,
      editing_attribute_item:null,

    }
  },
  computed:{
  	dragOptions() {
      return {
        animation: 200,
        disabled: false,
        ghostClass: "ghost"
      };
    },
  	is_connected()
  	{
  		
  		this.getLanguages()
      //this.getCustomAttributes()
  		if(this.$store.state.calculations.selectednode)
  		{
  			let selectednode = this.$store.state.calculations.selectednode
  			
  			let connections = this.$store.state.calculations.connections
  			let the_connection = connections.findIndex((item)=>{return item.to == selectednode.id})
  			if(the_connection!==-1)
  			{
  				let root_node = this.findRootNode()
  				return true
  			}
  			return false
  		}
  		return false  		
  	},
  },
  methods:{
  	end(event)
    { 
      this.drag = false
    },
    start(event)
    {
      this.drag = true
    },
    change(event)
    {
      console.log(event)      
    },
  	editItem(id)
  	{
  		this.setAllOutputNonEditing()
  		let selectednode = this.$store.state.calculations.selectednode
  		console.log(selectednode.data)
  		let selected_item_ind =  selectednode.data.outputs.findIndex((item)=>{return item.id == id})
  		this.editing_item =  selectednode.data.outputs[selected_item_ind]
  		selectednode.data.outputs[selected_item_ind].is_editing = true
  		this.updateNodeData(selectednode)
  	},
  	async deleteItem(id)
  	{
  		console.log(id)
      //return false
  		let formdata = new FormData()
      this.generalSubmission(formdata,"delete_node_column/"+id,this.afterDelete)
  		
  	},
  	afterDelete(response)
  	{
  		let selectednode = this.$store.state.calculations.selectednode
  		selectednode.data.outputs =  selectednode.data.outputs.filter((item)=>{return item.id !== response.data})
  		this.updateNodeData(selectednode)
  	},
  	cancelEditItem(id)
  	{
  		this.setAllOutputNonEditing()
  		let selectednode = this.$store.state.calculations.selectednode
  		let selected_item_ind =  selectednode.data.outputs.findIndex((item)=>{return item.id == id})
  		selectednode.data.outputs[selected_item_ind].is_editing = false
  		this.updateNodeData(selectednode) 
  	},
  	submitChanges(id)
  	{
  		let selectednode = this.$store.state.calculations.selectednode
  		let selected_item_ind =  selectednode.data.outputs.findIndex((item)=>{return item.id == id})
  		selectednode.data.outputs[selected_item_ind] = this.editing_item
  		selectednode.data.outputs[selected_item_ind].is_editing = false
  		this.updateNodeData(selectednode)
  		this.setAllOutputNonEditing()
  	},
  	setAllOutputNonEditing()
  	{
  		let selectednode = this.$store.state.calculations.selectednode
  		for(let output of selectednode.data.outputs)
  		{
  			output.is_editing = false
  		}
  		this.updateNodeData(selectednode)
  	},
    editAttributeItem(id)
    {
      this.setAllGroupNonEditing()

      let selectednode = this.$store.state.calculations.selectednode
      console.log(id)
      console.log(selectednode.data.groups)
      //return false
      let selected_item_ind =  selectednode.data.groups.findIndex((item)=>{return item.id == id})
      this.editing_attribute_item =  selectednode.data.groups[selected_item_ind]
      console.log(this.editing_attribute_item)
      selectednode.data.groups[selected_item_ind].is_editing = true
      this.updateNodeData(selectednode)
    },
    async deleteAttributeItem(id)
    {
      console.log(id)
      //return false
      let formdata = new FormData()
      this.generalSubmission(formdata,"delete_node_group/"+id,this.afterAttributeDelete)
      
    },
    afterAttributeDelete(response)
    {
      let selectednode = this.$store.state.calculations.selectednode
      selectednode.data.groups =  selectednode.data.groups.filter((item)=>{return item.id !== response.data})
      this.updateNodeData(selectednode)
    },
    cancelAttributeEditItem(id)
    {
      this.setAllGroupNonEditing()
      let selectednode = this.$store.state.calculations.selectednode
      let selected_item_ind =  selectednode.data.groups.findIndex((item)=>{return item.id == id})
      console.log(selected_item_ind)
      console.log(id)
      console.log(selectednode.data.groups)
      return false
      selectednode.data.groups[selected_item_ind].is_editing = false
      this.updateNodeData(selectednode) 
    },
    submitAttributeChanges(id)
    {
      console.log("submitAttributeChanges")
      
      let selectednode = this.$store.state.calculations.selectednode
      let selected_item_ind =  selectednode.data.groups.findIndex((item)=>{return item.id == id})
      console.log(id)
      console.log(selectednode.data.groups)
      console.log(this.editing_attribute_item)
      selectednode.data.groups[selected_item_ind] = this.editing_attribute_item
      selectednode.data.groups[selected_item_ind].is_editing = false
      this.updateNodeData(selectednode)
      this.setAllGroupNonEditing()
    },
    setAllGroupNonEditing()
    {
          let selectednode = this.$store.state.calculations.selectednode
          for(let output of selectednode.data.groups)
          {
                output.is_editing = false
          }
          this.updateNodeData(selectednode)
    },
    async getCustomAttributes()
    {
      let custom_attributes = await this.generalApiGetWithoutLoader("custom_attributes/brand_attributes/"+this.$route.params.id)
      custom_attributes = custom_attributes.filter((item)=>{return item.type=="select" || item.type=="booolean"})
      this.custom_attributes = custom_attributes
      console.log("custom_attributes")
      console.log(this.custom_attributes)
    },

    async getCustomAttributeOptions()
    {
      let customattribute_options = await this.generalApiGetWithoutLoader("custom_attributes/options/"+this.selected_custom_attribute.id)
      
      this.customattribute_options = customattribute_options
    },

    async getBrandFlows()
    {
      let brand_flows = await this.generalApiGetWithoutLoader("brand/flows/"+this.$route.params.id)
      brand_flows = brand_flows.filter((item)=>{return item.type!=="education" })
      this.brand_flows = brand_flows      
    },
    async getFlowInputfields()
    {
      let inputfields = await this.generalApiGetWithoutLoader("questionlists/all_inputfields/"+this.selected_flow.questionlist_id)
      this.inputfields = inputfields      
    },

    async getFlowInputfieldSections()
    {
      let inputfield_sections = await this.generalApiGetWithoutLoader("questionlists/sections/"+this.selected_flow.questionlist_id)
      this.inputfield_sections = inputfield_sections      
    },

    async getFlowNonconformityTypes()
    {
      let nonconformitytypes = await this.generalApiGetWithoutLoader("questionlistnonconformitytypes/"+this.selected_flow.questionlist_id)
      this.nonconformitytypes = nonconformitytypes      
    },

  	async getLanguages()
  	{
  		this.languages = await this.generalApiGetWithoutLoader("languages")
  		console.log("languages")
  	},
  	submitValue()
  	{
  		console.log(this.inputs)
  		console.log(this.$store.state.calculations.selectednode)
  		let obj = {
  			name:this.thevalue+ " - Değer",
  			type:"value",
  			id:Math.floor(Date.now() / 10),
  			value:this.thevalue
  		}
  		let selectednode = this.$store.state.calculations.selectednode
  		selectednode.data.output.inputs.push(obj)
  		this.updateNodeData(selectednode)
  		this.selected_input = null
  	},
  	cancelValue()
  	{
  		this.show_value_input = false
  		this.thevalue = 0
  		this.selected_input = null
  	},
  	inputSelected()
  	{
  		let type
  		if(this.selected_input.type=="value")
  		{
  			type = "value"
  			this.show_value_input = true
  		}
  		else
  		{
  			type = "input"
  			this.show_value_input = false
  		}
  		console.log("new_item")
  		console.log(this.selected_input)
  		this.new_item = {
  			name:this.selected_input.name,
  			input_stack_id:this.selected_input.stack_id,
  			id:Math.floor(Date.now() / 10),
  			translations:[],
  			value:null,
  			type:type,
  			is_editing:false,
  		}
  		for(let language of this.languages)
  		{
  			let lang_obj = {
  				name:this.selected_input.name,
  				language:language,  				
  			}
  			this.new_item.translations.push(lang_obj)
  		}
  		setTimeout(()=>{
  			this.show_add_output = true
  		},10)
  		
  	},
    groupTypeSelected()
    {
      this.show_group_add_output = false
      if(this.selected_group_type.id=="custom_attribute")
      {
        this.getCustomAttributes()
      }

      if(this.selected_group_type.id=="inputfield_section")
      {
        this.getBrandFlows()
      }

      if(this.selected_group_type.id=="inputfield")
      {
        this.getBrandFlows()
      }

      if(this.selected_group_type.id=="nonconformity_type")
      {
        this.getBrandFlows()
      }
    },

    customAttributeSelected()
    {
      console.log(this.selected_custom_attribute)
      if(this.selected_custom_attribute.type=="select")
      {
        this.getCustomAttributeOptions()
      }
      if(this.selected_custom_attribute.type=="boolean")
      {
        this.customattribute_options = []
        let open_option = {id:1,name:"Açık"}
        let close_option = {id:0,name:"Kapalı"}
        this.customattribute_options.push(open_option)
        this.customattribute_options.push(close_option)
      }
      
      
    },
    customAttributeOptionSelected()
    {
        this.new_group_item = {
        name:this.selected_custom_attribute.name+" - "+this.selected_customattribute_option.name,
        custom_attribute_id:this.selected_custom_attribute.id,
        custom_attribute_option_id:this.selected_customattribute_option.id,
        id:Math.floor(Date.now() / 10),
        value:null,
        type:this.selected_custom_attribute.type,
        is_editing:false,
        group_type:this.selected_group_type.id,
        grouping_method:"deger_toplam",
      }
      setTimeout(()=>{
        this.show_group_add_output = true
      },10)

    },

    async brandFlowSelected()
    {

      if(this.selected_group_type.id=="inputfield_section")
      {
        await this.getFlowInputfieldSections()
      }
      if(this.selected_group_type.id=="inputfield")
      {
        await this.getFlowInputfields()
      }
      if(this.selected_group_type.id=="nonconformity_type")
      {
        await this.getFlowNonconformityTypes()
      }
    },
    inputfieldSectionSelected()
    {
      console.log("new_item")
      console.log(this.selected_inputfield_section)
      //let new_group_item = this.new_group_item.new_group_item
      this.new_group_item = {
        name:this.selected_inputfield_section.name,
        inputfield_section_id:this.selected_inputfield_section.id,
        brand_flow_id:this.selected_flow,
        id:Math.floor(Date.now() / 10),
        value:null,
        is_editing:false,
        group_type:this.selected_group_type.id,
        grouping_method:"deger_toplam",
      }
      setTimeout(()=>{
        this.show_group_add_output = true
      },10)
    },

    inputfieldSelected()
    {
      console.log("new_item")
      console.log(this.selected_inputfield)
      //let new_group_item = this.new_group_item.new_group_item
      this.new_group_item = {
        name:this.selected_inputfield.name,
        inputfield_id:this.selected_inputfield.id,
        brand_flow_id:this.selected_flow,
        id:Math.floor(Date.now() / 10),
        value:null,
        is_editing:false,
        group_type:this.selected_group_type.id,
        grouping_method:"deger_toplam",
      }
      setTimeout(()=>{
        this.show_group_add_output = true
      },10)
    },

    nonconformityTypeSelected()
    {
      console.log("new_item")
      console.log(this.selected_nonconformity_type)
      //let new_group_item = this.new_group_item.new_group_item
      this.new_group_item = {
        name:this.selected_nonconformity_type.name,
        nonconformity_id:this.selected_nonconformity_type.id,
        brand_flow_id:this.selected_flow,
        id:Math.floor(Date.now() / 10),
        value:null,
        is_editing:false,
        group_type:this.selected_group_type.id,
        grouping_method:"deger_toplam",
      }
      setTimeout(()=>{
        this.show_group_add_output = true
      },10)
    },


  	cancelNewItem()
    {
      this.show_add_output = false
      this.show_value_input = false
      this.selected_input = null
    },

    cancelNewAttributeItem()
    {
      this.show_group_add_output = false
      this.selected_custom_attribute = null
      this.selected_group_type = null
    },


  	submitNewItem()
    {
      let selectednode = this.$store.state.calculations.selectednode
      console.log(selectednode)
      //return false
      selectednode.data.outputs.push(this.new_item)
      this.updateNodeData(selectednode)
      setTimeout(()=>{
        this.cancelNewItem()
      },10)
    },

    submitNewAttributeItem()
    {
      let selectednode = this.$store.state.calculations.selectednode
      console.log(selectednode)
      //return false
      if(selectednode.data.groups)
      {
        selectednode.data.groups.push(this.new_group_item)
      }
      else
      {
        selectednode.data.groups = []
        selectednode.data.groups.push(this.new_group_item)
      }
      
      this.updateNodeData(selectednode)
      setTimeout(()=>{
        this.cancelNewAttributeItem()
      },10)
    },

  	updateNodeData(selectednode)
  	{
  		let nodes = this.$store.state.calculations.nodes
  		let ind = nodes.findIndex((item)=>{return item.id == selectednode.id})
  		nodes[ind] = selectednode
  		this.$store.dispatch('calculations/setNodes',nodes)
      this.$store.dispatch('calculations/setSelectedNode',selectednode)
  	},
  	findRootNode()
  	{
  		let selectednode = this.$store.state.calculations.selectednode
  		let connections = this.$store.state.calculations.connections
  		let nodes = this.$store.state.calculations.nodes
  		let the_connection = connections.find((item)=>{return item.to == selectednode.id.toString()}) 
  		if(the_connection)
  		{  			
  			let from_node = this.findPrevNode(the_connection.from)  			
  			return from_node
  		}
  		return "no_connection"
  	},
  	findPrevNode(nodeId)
  	{
  		let connections = this.$store.state.calculations.connections
  		let nodes = this.$store.state.calculations.nodes
  		let node = nodes.find((item)=>{return item.id == nodeId.toString()})
  		console.log("findPrevNode")
  		console.log(node)
  		if(node.key=="calculations")
		{  				
			let calculation_item = {
            stack_id:node.id,
            name:node.title,
            type:"calculation",
          }
          this.addToInputsStack(calculation_item)
		}
  		//if prev node is not suppliers
  		if(node.type!=="suppliers")
  		{
  			let the_connection = connections.find((item)=>{return item.to == nodeId.toString()})
  			if(!the_connection)
  			{
  				return "no_connection"
  			}
  			let from_node = this.findPrevNode(the_connection.from) 
  			
  			
  			return from_node
  		}
  		//if prev node is not suppliers

  		//if prev node is suppliers
  		node = this.sanitizeArray(node)
  		let outputs = node.data.outputs
  		console.log("OUTPUTS")
      console.log(outputs)
  		for(let item of outputs)
  		{
        /*
  			console.log(item.type)
  			if(item.name.length>40)
				{
					item.name = item.name.substring(0, 40)+"..."
				}
				if(item.type)
				{
					item.name = item.name + " - " + item.type
				}
        */
				
  			this.addToInputsStack(item)
  		}
  		return node
  		//if prev node is suppliers

  	},
  	addToInputsStack(input)
  	{
  		
  		this.inputs.push(input)
  	},
  },
}
</script>

<style lang="css" scoped>
	.handle{
		cursor: pointer;
	}
</style>